/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs */

const en_forms_teams_settings_phone_is_user_allowed_to_toggle_speaker = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Speaker`)
};

const de_forms_teams_settings_phone_is_user_allowed_to_toggle_speaker = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umschalten der Lautsprecher erlaubt`)
};

/**
* | output |
* | --- |
* | "Toggle Speaker" |
*
* @param {Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_is_user_allowed_to_toggle_speaker = /** @type {((inputs?: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Is_User_Allowed_To_Toggle_SpeakerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_is_user_allowed_to_toggle_speaker(inputs)
	return de_forms_teams_settings_phone_is_user_allowed_to_toggle_speaker(inputs)
});